module.exports = __webpack_public_path__ + "static/media/scanner-touchscreen.9ce24ab1.svg";